'use client';

import { c as _c } from "react/compiler-runtime";
import { BorderBeam } from 'border-beam';
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { ConfusedIconSolid } from '@/components/ui/icon/glyphs';
import { cn } from '@/lib/ui/utils';
interface InteractiveExplainerButtonProps {
  /** Close the hosting modal and open the simulated trade flow. */
  onOpen: () => void;
  /** Forwarded to the button so `ModalFooter` can size it like its siblings. */
  className?: string;
}

/**
 * "Confused? Watch our explainer" — the leading footer action of the market and
 * proposal how-it-works modals, grown to fill the row beside "Got it". Wears the
 * same `BorderBeam` inner-border glow as the AI proposal name entry (default `md`
 * preset — the `sm` preset is sized for a fixed 70×36 chip and collapses to a
 * blob on a wide button).
 */
export function InteractiveExplainerButton(t0) {
  const $ = _c(8);
  const {
    onOpen,
    className
  } = t0;
  const t = useTranslations("simulated_trade");
  let t1;
  if ($[0] !== className) {
    t1 = cn("w-full", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("open_cta");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onOpen || $[5] !== t1 || $[6] !== t2) {
    t3 = <BorderBeam colorVariant="colorful" theme="auto" className="min-w-0 shrink grow basis-full sm:basis-0"><AnimatedButton variant="secondary" className={t1} prefix={ConfusedIconSolid} onClick={onOpen}>{t2}</AnimatedButton></BorderBeam>;
    $[4] = onOpen;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}